import { IBar, IScoreEditorThis } from "../../../../../common/types";
import { getRealLength } from "./getRealLength";

export const handleTrupletInput = function (this: IScoreEditorThis) {
  const { activeVoice, selectedNote } = this.state;
  const score = { ...this.state.score };
  const bars = score["bars" + (activeVoice || "")] as IBar[];
  if (selectedNote?.lyric) return;
  let barLength = 0;
  bars[bars.length - 1].notes.forEach(note => {
      barLength += getRealLength(note) * (note.t ? 2 : 3);
  });
  if (barLength / 3 !== Math.round(barLength / 3)) return;
  if (score.trupletLeft === 3) {
      score.trupletLeft = 0;
  } else if (score.trupletLeft === 0 || score.trupletLeft === undefined) {
      score.trupletLeft = 3;
  }
  this.setState({ score });
};